module.exports = __webpack_public_path__ + "img/composite.19dfa876.png";